import React, { useState } from 'react';
import { casesList } from './config';
import anime from 'animejs';
import { useDidUpdate } from '@dobux/hooks';

export default function InfoCard(props: { selectIndex: number }) {
    const { selectIndex } = props;

    const [curIndex, setCurIndex] = useState(selectIndex);
    const item = casesList[curIndex];
    useDidUpdate(() => {
        setCurIndex(selectIndex);
        const item = casesList[selectIndex];
        item.content.data.map((i, index) => {
            anime({
                targets: [`.show-card .data-num-${index}`],
                innerHTML: [0, i.value],
                opacity: [1, 1],
                round: 1,
                easing: 'linear',
                duration: 500,
            });
        });
    }, [selectIndex]);

    return (
        <div className="show-card">
            <div className="title-wrapper">
                <div className="title">
                    <i />
                    <span>{item.type}</span>·<span>{item.title}</span>
                </div>
            </div>
            <div className="desc-wrapper">
                <div className="desc">{item.desc}</div>
            </div>
            <div className="text-wrapper">
                <div className="content-text">{item.content.text}</div>
            </div>
            <div className="data">
                {[0, 1].map((index) => (
                    <span
                        className="data-item"
                        key={index}
                        style={{ opacity: item.content.data[index] ? 1 : 0 }}
                    >
                        <span>
                            <span className={`data-num-${index}`}>
                                {item.content.data[index]?.value}
                            </span>
                            %
                        </span>
                        <div className="data-desc">{item.content.data[index]?.title}</div>
                    </span>
                ))}
            </div>
        </div>
    );
}
